<script setup lang="ts">
import { ERdrChannel, ERdrChannelLabels, hasAvailableRdrChannel } from '@/types/enum/RdrChannelEnum'
import type { CheckpointAssociateErrorModel } from '@/types/models/CheckpointModel'
import type { DeviceModel } from '@/types/models/DeviceModel'
import { RadioButton, StackLayout, TypographyItem } from '@rfc/rfc-components-library'
import { type DateProviderType, EProviders } from '@rfc/rfc-components-library/types'
import moment from 'moment'
import { computed, inject } from 'vue'

const { DATE_FORMAT } = inject<DateProviderType>(EProviders.DATE, {})

type Props = {
    device?: Partial<DeviceModel>
    associates?: Partial<DeviceModel>[]
    associateError?: CheckpointAssociateErrorModel[]
    selectedRdrChannel?: ERdrChannel
}
const props = defineProps<Props>()
type Emits = {
    (e: 'selectChannel', value: ERdrChannel): void
}
defineEmits<Emits>()

const availableRdrChannels = computed(() =>
    props.device && props.associates
        ? hasAvailableRdrChannel(props.device, props.associates)
        : undefined
)
</script>

<template>
    <template v-if="availableRdrChannels && availableRdrChannels?.length">
        <StackLayout direction="column" :gap="8">
            <TypographyItem :label="$t('device.actions.rdrChannels.rdrChannelsText')" />
            <RadioButton
                :modelValue="selectedRdrChannel"
                @change="$emit('selectChannel', $event as ERdrChannel)"
                :options="
                    availableRdrChannels?.map(value => ({
                        name: $t(ERdrChannelLabels[value]?.label, { channel: value }),
                        value
                    }))
                " />
        </StackLayout>
    </template>
    <template v-if="associateError && associateError?.length">
        <StackLayout direction="column" :gap="8">
            <TypographyItem :label="$t('checkpoint.detail.alreadyAssociatedCheckpoints')" />
            <TypographyItem
                v-for="(item, index) in associateError"
                :key="index"
                :label="`${item.event} - ${item.checkpoint} - ${$t('date.from')} ${moment(
                    item.start_at
                ).format(DATE_FORMAT)} ${$t('date.to')} ${moment(item.start_at).format(
                    DATE_FORMAT
                )}`" />
        </StackLayout>
    </template>
</template>
